<template lang="html">
<section class="preview pa-5">
    <h1>תצוגה מקדימה</h1>

    <v-tabs v-model="tab">
        <v-tab :href="'#' + tab.os" v-for="tab in devices">{{tab.os}}</v-tab>

    </v-tabs>
    <br />
    <br />
    <v-tabs-items v-model="tab">
        <v-tab-item :value="tab.os" v-for="tab in devices">
            <div :class="'device ' +  tab.code">
                <div class="device-frame">
                    <img class="device-content" :src="'/img/background/' + tab.os + '.png'">
                    <div class="clock">
                      <div class="hour">{{hour}}</div>
                      <div class="date">{{date}}</div>
                      <NotifyIOS v-if="tab.os == 'iphone'"/>
                      <NotifyAndroid v-if="tab.os == 'android'"/>
                    </div>
                </div>
                <div class="device-stripe"></div>
                <div class="device-sensors"></div>
                <div class="device-btns"></div>
                <div class="device-power"></div>
            </div>
        </v-tab-item>

    </v-tabs-items>

    </div>

</section>
</template>

<script lang="js">
import { format, parse } from 'date-fns'
import NotifyIOS from '@/components/NotifyIOS.vue'
import NotifyAndroid from '@/components/NotifyAndroid.vue'

const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_TIME_FORMAT = 'HH:mm:ss'

export default {
    name: 'preview',
    props: [],
    components: {
      NotifyIOS,
      NotifyAndroid
    },
    mounted() {

    },
    data() {
        return {
            tab: 1,
            devices: [{
                code: "device-google-pixel-2-xl",
                os: "android"
            }, {
                code: "device-iphone-x",
                os: "iphone"
            }]
        }
    },
    methods: {

    },
    computed: {
      hour() {
        return format(new Date(), 'HH:mm')
      },
      date() {
        return format(new Date(), 'EEE, MMM dd')
      }
    }
}
</script>

<style lang="scss" scoped>
.clock {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  
  position: absolute;
  top: 0%;
  left: 0%;
  height: 80%;
  width: 100%;
}

.hour {
  font-size: 72px;
}
</style>
